export default "__VITE_ASSET__Rwl6bt1F__"